export class Overlay {
  private overlay: Element | null

  constructor() {
    this.overlay = document.querySelector('#js-page-overlay')

    if (!this.overlay) return

    this.bindSearch()
    this.bindClose()
    this.inputKeys()
  }

  close(): void {
    if (!this.overlay || !this.overlay.classList.contains('active')) return
      
    this.overlay.classList.remove('active')
    this.overlay.classList.remove('search')
    this.overlay.setAttribute('aria-hidden', 'true')

    const searchBox = this.overlay.querySelector('.js-search-box')
    searchBox?.classList.remove('active')

    const searchToggle = document.querySelector('.js-search-toggle')
    searchToggle?.setAttribute('aria-expanded', 'false')

    const navigation = document.querySelector('#js-navigation')
    navigation?.classList.remove('active')

    const hamburger = document.querySelector('.js-hamburger')
    hamburger?.classList.remove('active')

    document.body.classList.remove('scroll-locked')

    // Clear search inputs
    const searchInputs = document.querySelectorAll('.js-search-form input') as NodeListOf<HTMLInputElement>
    searchInputs.forEach((input) => {
      input.value = ''
    })
  }

  bindClose(): void {
    this.overlay?.addEventListener('click', (e) => {
      const target = e.target as Element
      if (target.classList.contains('js-close')) {
        this.close()
      }
    })

    // Close on outside click
    document.addEventListener('mouseup', (e) => {
      const target = e.target as Element
      if (target === this.overlay) {
        this.close()
      }
    })
  }

  inputKeys(): void {
    const searchForm = document.querySelector('.js-search-form')
    const searchInput = searchForm?.querySelector('input') as HTMLInputElement | null

    document.addEventListener('keyup', (e) => {
      // Escape key
      if (e.keyCode === 27) {
        this.close()
      }

      // Update search form state
      if (searchInput && document.activeElement === searchInput && searchInput.value) {
        searchForm?.classList.add('active')
      } else {
        searchForm?.classList.remove('active')
      }
    })
  }

  bindSearch(): void {
    if (!this.overlay) return
    
    const box = this.overlay.querySelector('.js-search-box')
    const searchToggle = document.querySelector('.js-search-toggle')
    if (!searchToggle) return

    searchToggle.addEventListener('click', () => {
      if (!this.overlay) return
      
      // Remove active class from all elements in overlay
      const activeElements = this.overlay.querySelectorAll('.active')
      activeElements.forEach((el) => el.classList.remove('active'))

      this.overlay.classList.add('active')
      this.overlay.classList.add('search')
      this.overlay.setAttribute('aria-hidden', 'false')
      searchToggle.setAttribute('aria-expanded', 'true')
      if (box) {
        box.classList.add('active')
        const input = box.querySelector('input') as HTMLInputElement | null
        input?.focus()
      }
    })
  }
}
